<template>
    <span data-test="badge" class="tw:flex tw:items-center tw:gap-2 tw:font-semibold tw:text-xs tw:uppercase" :class="variantClasses">
        <i v-if="icon" data-test="badge-icon" :class="icon"></i>
        <slot>{{ label }}</slot>
    </span>
</template>

<script setup>
    import { computed } from 'vue';

    const props = defineProps({
        label:       { type: String, default: '' },
        icon:        { type: String, default: null },
        variant:     { type: String, default: 'default' },
        customClass: { type: String, default: '' },
    });

    const variantClasses = computed(() => {
        const map = {
            success:  'tw:text-green-500',
            primary:  'tw:text-blue-500',
            info:     'tw:text-cyan-500',
            purple:   'tw:text-purple-500',
            warning:  'tw:text-yellow-500',
            danger:   'tw:text-red-500',
            default:  'tw:text-gray-400',
        };
        const baseVariant = map[props.variant] ?? map.default;
        return [baseVariant, props.customClass].filter(Boolean).join(' ');
    });
</script>
